<mat-expansion-panel [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>STEP 1 - REVIEW SITE / APPROVE MAP</mat-panel-title>
    <mat-panel-description>
      <div *ngIf="stepComplete">
        <fa-icon [icon]="['fas', 'check']" class="green size-20"></fa-icon>
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <mat-divider></mat-divider>

  <div class="section-content" *ngIf="site">
    <div class="section-container">
      <fc-site-detail-overview [readOnly]="false" [isSuperAdmin]="isSuperAdmin"></fc-site-detail-overview>

      <form class="w-100-1" [formGroup]="siteOverviewNoteForm">
        <mat-form-field class="field w-100-1">
          <mat-label>Notes</mat-label>
          <textarea class="textarea" formControlName="note" id="siteOverviewNote" matInput rows="4"></textarea>
        </mat-form-field>
      </form>

      <div class="buttons w-100-1">
        <button
          color="primary"
          mat-stroked-button
          [disabled]="siteOverviewNoteForm?.pristine"
          (click)="cancelSiteReviewNote(siteOverviewNoteForm.getRawValue())">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          (click)="saveSiteReviewNote(siteOverviewNoteForm.getRawValue())"
          [disabled]="siteOverviewNoteForm?.pristine"
          data-cy="button-save-overview-note">
          Save
        </button>
      </div>
    </div>

    <mat-divider></mat-divider>
    <!-- Identity Verification Section -->
    <div class="section-container" data-cy="site-identity-verification-section">
      <div class="section-header w-100-1">Identity Verification</div>
      <div *ngIf="flaggedProfile" class="flagged-profile" data-cy="flagged-profile">
        <fa-icon [icon]="['far', 'flag']"></fa-icon>
        User Name or Email Changed. Please review history.
      </div>
      <div class="info-container w-100-1">
        <div class="label">System Verified:</div>
        <div class="field">
          {{ this.site?.account.user.isSystemVerified ? 'Yes' : 'No' }}
        </div>
      </div>
      <div class="info-container w-100-1">
        <div class="label">Manual Verified:</div>
        <div class="field">
          {{ this.site?.account.user.isManuallyVerified ? 'Yes' : 'No' }}
        </div>
      </div>
      <ng-container *ngIf="this.site?.account.user.isManuallyVerified">
        <div class="info-container w-100-1">
          <div class="label">Manually Verified By:</div>
          <div class="field">
            {{
              this.site?.account.user.isManuallyVerified && this.site?.account.user.verifiedBy
                ? this.site?.account.user.verifiedBy.getDisplayName()
                : ''
            }}
          </div>
        </div>
      </ng-container>
      <form class="w-100-1" [formGroup]="identityVerificationNoteForm">
        <mat-form-field class="field w-100-1">
          <mat-label>Notes</mat-label>
          <textarea
            class="w-100-1 textarea"
            formControlName="note"
            id="identityVerificationNote"
            matInput
            rows="4"></textarea>
        </mat-form-field>
      </form>
      <div class="buttons w-100-1">
        <button
          color="primary"
          mat-stroked-button
          [disabled]="identityVerificationNoteForm?.pristine"
          (click)="cancelSiteReviewNote(identityVerificationNoteForm.getRawValue())">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="identityVerificationNoteForm?.pristine"
          (click)="saveSiteReviewNote(identityVerificationNoteForm.getRawValue())"
          data-cy="button-save-identity-verification-note">
          Save
        </button>
      </div>
    </div>

    <mat-divider></mat-divider>
    <!-- Parcel Ownership Section -->
    <div class="section-container">
      <div class="section-header w-100-1">Parcel Ownership</div>
      <div class="info-container w-100-1">
        <div class="label w-35-2">Ownership Assessment</div>
        <div class="field">
          <mat-radio-group
            [(ngModel)]="ownerNamesAndParcelIDsVerifiedCheck.status"
            (change)="saveSiteReviewCheck($event, ownerNamesAndParcelIDsVerifiedCheck)">
            <mat-radio-button
              *ngFor="let option of possibleValues"
              [id]="'ownerNamesAndParcelIDsVerifiedCheck' + option"
              [value]="option">
              {{ option }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="info-container w-100-1" *ngIf="ownerNamesAndParcelIDsVerifiedCheck.updatedBy">
        <div class="label w-35-2">Clicked By:</div>
        <div class="field">
          {{ getCheckClickedByLine(ownerNamesAndParcelIDsVerifiedCheck) }}
        </div>
      </div>
      <div class="info-container w-100-1">
        <div class="label w-35-2">Evidence of Restricted Covenants</div>
        <div class="field">
          <mat-radio-group
            [(ngModel)]="restrictedCovenantsCheck.status"
            (change)="saveSiteReviewCheck($event, restrictedCovenantsCheck)">
            <mat-radio-button
              *ngFor="let option of possibleValues"
              [id]="'restrictedCovenantsCheck' + option"
              [value]="option">
              {{ option }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="info-container w-100-1" *ngIf="restrictedCovenantsCheck.updatedBy">
        <div class="label w-35-2">Clicked By:</div>
        <div class="field">
          {{ getCheckClickedByLine(restrictedCovenantsCheck) }}
        </div>
      </div>
      <div *ngIf="documents" class="site-document-list">
        <div *ngFor="let document of documents; index as i" class="document-link" (click)="downloadDocument(document)">
          <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" class="blue"></fa-icon>
          <span>
            {{ getDocumentTypeName(document.documentTypeId) }} -
            {{ document.name }}
          </span>
        </div>
      </div>
      <table [dataSource]="parcelData" class="parcel-list-table" mat-table aria-describedby="List of Parcels">
        <ng-container matColumnDef="parcelNum">
          <th scope="col" *matHeaderCellDef mat-header-cell>Parcel Number</th>
          <td *matCellDef="let parcelElement" mat-cell>
            <fa-icon
              (click)="editParcel(parcelElement)"
              [icon]="['far', 'pen-to-square']"
              class="blue edit-parcel"></fa-icon>
            {{ parcelElement.parcelNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="owner">
          <th scope="col" *matHeaderCellDef mat-header-cell>Owner Name</th>
          <td *matCellDef="let parcelElement" mat-cell>
            {{ parcelElement.owner }}
          </td>
        </ng-container>
        <ng-container matColumnDef="county">
          <th scope="col" *matHeaderCellDef mat-header-cell>County</th>
          <td *matCellDef="let parcelElement" mat-cell>
            {{ parcelElement.county }}
          </td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th scope="col" *matHeaderCellDef mat-header-cell>State</th>
          <td *matCellDef="let parcelElement" mat-cell>
            {{ parcelElement.state }}
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>

      <form class="w-100-1" [formGroup]="parcelOwnershipNoteForm">
        <mat-form-field class="field w-100-1">
          <mat-label>Notes</mat-label>
          <textarea
            class="w-100-1 textarea"
            id="parcelOwnershipNote"
            formControlName="note"
            matInput
            rows="4"></textarea>
        </mat-form-field>
      </form>
      <div class="buttons w-100-1">
        <button
          color="primary"
          mat-stroked-button
          [disabled]="parcelOwnershipNoteForm?.pristine"
          (click)="cancelSiteReviewNote(parcelOwnershipNoteForm.getRawValue())">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="parcelOwnershipNoteForm?.pristine"
          (click)="saveSiteReviewNote(parcelOwnershipNoteForm.getRawValue())"
          data-cy="button-save-parcel-ownership-note">
          Save
        </button>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="section-container">
      <div class="section-header w-100-1">Site Check</div>
      <div class="info-container w-100-1">
        <div class="label w-30-2">Google Earth Engine Change Detection Verified:</div>
        <div class="field">
          <mat-radio-group
            [(ngModel)]="googleEarthEngineChangeDetectionVerifiedCheck.status"
            (change)="saveSiteReviewCheck($event, googleEarthEngineChangeDetectionVerifiedCheck)">
            <mat-radio-button
              *ngFor="let option of possibleValues"
              [id]="'googleEarthEngineChangeDetectionVerifiedCheck' + option"
              [value]="option">
              {{ option }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="info-container w-100-1" *ngIf="googleEarthEngineChangeDetectionVerifiedCheck.updatedBy">
        <div class="label w-30-2">Clicked By:</div>
        <div class="field">
          {{ getCheckClickedByLine(googleEarthEngineChangeDetectionVerifiedCheck) }}
        </div>
      </div>
      <div class="info-container w-100-1">
        <div class="label w-30-2">Map Approved:</div>
        <div class="field">
          <mat-radio-group [(ngModel)]="mapApproved.status" (change)="saveSiteReviewCheck($event, mapApproved)">
            <mat-radio-button *ngFor="let option of possibleValues" [id]="'mapApproved' + option" [value]="option">
              {{ option }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="info-container w-100-1" *ngIf="mapApproved.updatedBy">
        <div class="label w-31-2">Clicked By:</div>
        <div class="field">{{ getCheckClickedByLine(mapApproved) }}</div>
      </div>
      @if (redflagDetails.length > 0) {
        <table
          [dataSource]="redflagDetails"
          class="redflag-list-table"
          mat-table
          aria-describedby="Redflag Overlap Details">
          <ng-container matColumnDef="layerName">
            <th scope="col" *matHeaderCellDef mat-header-cell>Redflag Layer</th>
            <td *matCellDef="let redflag" mat-cell>
              {{ redflagMap[redflag.layer] ? redflagMap[redflag.layer] : redflag.layer }}
            </td>
          </ng-container>
          <ng-container matColumnDef="area">
            <th scope="col" *matHeaderCellDef mat-header-cell>Area Overlap</th>
            <td *matCellDef="let redflag" mat-cell>{{ redflag.area | number: '1.0-2' }} acres</td>
          </ng-container>

          <tr *matHeaderRowDef="['layerName', 'area']" mat-header-row></tr>
          <tr *matRowDef="let row; columns: ['layerName', 'area']" mat-row></tr>
        </table>
      }
      <form class="w-100-1" [formGroup]="siteCheckNoteForm">
        <mat-form-field class="field w-100-1">
          <mat-label>Notes</mat-label>
          <textarea class="textarea w-100-1" formControlName="note" id="siteCheckNote" matInput rows="4"></textarea>
        </mat-form-field>
      </form>
      <div class="buttons w-100-1">
        <button
          color="primary"
          mat-stroked-button
          [disabled]="siteCheckNoteForm?.pristine"
          (click)="cancelSiteReviewNote(siteCheckNoteForm.getRawValue())">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="siteCheckNoteForm?.pristine"
          (click)="saveSiteReviewNote(siteCheckNoteForm.getRawValue())"
          data-cy="button-save-site-check-note">
          Save
        </button>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Other Forest of Land-Use Programs -->
    <div class="section-container">
      <div class="section-header">Other Forest or Land-Use Programs</div>
      <div class="program-tiles-container w-100-1">
        <div *ngFor="let program of programs" class="program">
          <div class="program-tile">
            <div class="program-name">
              <div *ngIf="program.restrictionLevel === -1">
                <fa-icon [icon]="['fas', 'question']" class="blue"></fa-icon>
              </div>
              <div *ngIf="program.restrictionLevel === 0">
                <fa-icon [icon]="['fas', 'circle']" class="green"></fa-icon>
              </div>
              <div *ngIf="program.restrictionLevel === 1">
                <fa-icon [icon]="['fas', 'triangle']" class="yellow"></fa-icon>
              </div>
              <div *ngIf="program.restrictionLevel === 2">
                <fa-icon [icon]="['fas', 'octagon']" class="red"></fa-icon>
              </div>
              <span class="program-type">{{ program.type }}:</span>
              {{ program.name }}
              <span *ngIf="program.name === 'Leakage'">
                <div class="leakage-document-list">
                  <div
                    *ngFor="let document of leakageDocs; index as i"
                    class="document-link leakage"
                    (click)="downloadDocument(document)">
                    <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" class="blue"></fa-icon>
                    <span>{{ document.name }}</span>
                  </div>
                </div>
              </span>
            </div>
            <div *ngIf="program.note" [ngStyle]="{ 'margin-top': '4px' }">
              {{ program.note }}
            </div>
          </div>
        </div>
      </div>
      <button (click)="editPrograms()" *ngIf="!stepComplete" class="add-programs" color="primary" mat-stroked-button>
        Add/Remove Programs
      </button>
      <div class="info-container w-100-1">
        <div class="label">All Supporting Documents Provided:</div>
        <div class="field">
          <mat-radio-group
            [(ngModel)]="allSupportingDocumentsProvided.status"
            (change)="saveSiteReviewCheck($event, allSupportingDocumentsProvided)">
            <mat-radio-button
              *ngFor="let option of possibleValues"
              [id]="'allSupportingDocumentsProvided' + option"
              [value]="option">
              {{ option }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="info-container w-100-1" *ngIf="allSupportingDocumentsProvided.updatedBy">
        <div class="label w-30-2">Clicked By:</div>
        <span class="value">
          {{ getCheckClickedByLine(allSupportingDocumentsProvided) }}
        </span>
      </div>
      <div class="section-container w-100-1">
        <form class="w-100-1" [formGroup]="supportingDocumentsNoteForm">
          <mat-form-field class="field w-100-1">
            <mat-label>Notes</mat-label>
            <textarea class="textarea" formControlName="note" id="supportingDocumentsNote" matInput rows="4"></textarea>
          </mat-form-field>
        </form>
        <div class="buttons w-100-1">
          <button
            color="primary"
            mat-stroked-button
            [disabled]="supportingDocumentsNoteForm?.pristine"
            (click)="cancelSiteReviewNote(supportingDocumentsNoteForm.getRawValue())">
            Cancel
          </button>
          <button
            mat-flat-button
            [disabled]="supportingDocumentsNoteForm?.pristine"
            color="primary"
            (click)="saveSiteReviewNote(supportingDocumentsNoteForm.getRawValue())"
            data-cy="button-save-supporting-note">
            Save
          </button>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Buyer Specific Requirements / Document Section -->
    <div class="section-container">
      <div class="section-header w-100-1">Other</div>
      <div class="info-container">
        <div class="label">Buyer Specific Requirement / Document:</div>
        <div class="field">
          <mat-radio-group
            [(ngModel)]="buyerSpecificRequirementDocument.status"
            (change)="saveSiteReviewCheck($event, buyerSpecificRequirementDocument)">
            <mat-radio-button
              *ngFor="let option of possibleValues"
              [id]="'buyerSpecificRequirementDocument' + option"
              [value]="option">
              {{ option }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="w-100-1 info-container" *ngIf="buyerSpecificRequirementDocument.updatedBy">
        <div class="label w-30-2">Clicked By:</div>
        <div class="field">
          {{ getCheckClickedByLine(buyerSpecificRequirementDocument) }}
        </div>
      </div>

      <form class="w-100-1" [formGroup]="otherNoteForm">
        <mat-form-field class="field w-100-1">
          <mat-label>Notes</mat-label>
          <textarea formControlName="note" id="otherNote" class="textarea" matInput rows="4"></textarea>
        </mat-form-field>
      </form>
      <div class="buttons w-100-1">
        <button
          color="primary"
          mat-stroked-button
          [disabled]="otherNoteForm?.pristine"
          (click)="cancelSiteReviewNote(otherNoteForm.getRawValue())">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="otherNoteForm?.pristine"
          (click)="saveSiteReviewNote(otherNoteForm.getRawValue())"
          data-cy="button-save-other-note">
          Save
        </button>
      </div>
    </div>

    <mat-divider></mat-divider>
    <!-- Annual Valuation Adjustment Section -->
    <div *ngIf="!stepComplete">
      <div class="section-header">Annual Valuation Adjustment</div>
      <div class="value-adjustment-description">
        If the landowner's site lines do not match CORE's satellite mapping - you can make an annual adjustment to their
        ERT valuation here.
        <br />
        <p>Current Annual Valuation: {{ valuation }}</p>
      </div>
      <form [formGroup]="updatesForm" class="updates-form">
        <mat-form-field>
          <mat-label>Add or Subtract Amount
            <fa-icon
              #tooltip="matTooltip"
              (click)="tooltip.toggle()"
              [icon]="['far', 'circle-info']"
              class="blue"
              matTooltip="The ERT adjustment, in decimal form. Enter a (-) for a negative adjustment. e.g. -12.3456"
              matTooltipClass="fc-tooltip"
              matTooltipPosition="right"></fa-icon>
          </mat-label>
          <input formControlName="initialAdjustment" id="value-adjustment" matInput type="number" />
        </mat-form-field>
      </form>
    </div>

    <mat-divider *ngIf="!stepComplete"></mat-divider>

    <div [ngClass]="stepComplete ? 'map-action-buttons-wrapper left-align' : 'map-action-buttons-wrapper'">
      <button (click)="downloadAdminChecklist()" class="button-margin-right" color="primary" mat-stroked-button>
        Download Checklist
      </button>
      <button
        (click)="onRequestMapRevisions()"
        class="button-margin-right"
        color="primary"
        [disabled]="!siteHelper.siteSubmittedStatusList.includes(site.status)"
        mat-stroked-button>
        Request Revisions
      </button>
      <button
        (click)="onApproveMap()"
        *ngIf="!stepComplete && isCurrentStep"
        color="primary"
        data-cy="button-approve-map"
        mat-raised-button>
        Approve Site
      </button>
    </div>
  </div>
</mat-expansion-panel>
